import React,{useState} from 'react'
import AtmosphereStorageForm from './AtmosphereStorageForm';
import AtmosphereStorageList from './AtmosphereStorageList';

const AtmosphereStorage = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <AtmosphereStorageForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <AtmosphereStorageList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
      </>
    );
}

export default AtmosphereStorage